import { PageLoansCreate } from './Create';
import { DISBURSEMENTS } from './Disbursement';
import { PageLoanDisbursements } from './Disbursements';
import { PageLoanInformation } from './Information';
import { PageLoan } from './Loan';
import { PageLoans } from './Overview';
import { PAYMENTS } from './Payment';
import { PageLoanPayments } from './Payments';
import { PageLoansSale } from './Sale';

export const LOANS = {
  Loans: PageLoans,
  LoanSection: PageLoan,
  LoansEdit: PageLoanInformation,
  LoansCreate: PageLoansCreate,
  LoanPayments: PageLoanPayments,
  LoanDisbursements: PageLoanDisbursements,
  LoansSale: PageLoansSale,
  ...DISBURSEMENTS,
  ...PAYMENTS,
} as const;
